import React from 'react';
import './Sprite.scss';
import carFull from '../../assets/illustrations/car-full.webp';
import carPartial from '../../assets/illustrations/car-partial.webp';
import carTire from '../../assets/illustrations/car-tire.webp';
import piggyCoin from '../../assets/illustrations/piggy-coin.webp';
import shieldHappy from '../../assets/illustrations/shield-happy.webp';
import shieldCracked from '../../assets/illustrations/shield-cracked.webp';
import faceCalm from '../../assets/illustrations/face-calm.webp';
import faceEuphoria from '../../assets/illustrations/face-euphoria.webp';
import facePanic from '../../assets/illustrations/face-panic.webp';
import faceDespair from '../../assets/illustrations/face-despair.webp';
import faceHesitate from '../../assets/illustrations/face-hesitate.webp';
import faceGreed from '../../assets/illustrations/face-greed.webp';
import leverCoin from '../../assets/illustrations/lever-coin.webp';
import goldTrophy from '../../assets/illustrations/gold-trophy.webp';
import pigPink from '../../assets/illustrations/pig-pink.webp';
import pigGrey from '../../assets/illustrations/pig-grey.webp';
import pigGreen from '../../assets/illustrations/pig-green.webp';
import pigBlue from '../../assets/illustrations/pig-blue.webp';
import pigPurple from '../../assets/illustrations/pig-purple.webp';
import pigRed from '../../assets/illustrations/pig-red.webp';
import pigYellow from '../../assets/illustrations/pig-yellow.webp';
import pigOrange from '../../assets/illustrations/pig-orange.webp';
import pigTeal from '../../assets/illustrations/pig-teal.webp';

/**
 * The small characters that fill an empty corner of a 理財概念 chart: a car, piggy banks, a shield and the
 * investor's faces. They were generated with the image model, keyed out to a transparent background and
 * shrunk to 13-26 KB each (see scripts/gen-illustration.js). Decorative: the words beside them carry the meaning.
 */

const SPRITES = {
  'car-full': carFull,
  'car-partial': carPartial,
  'car-tire': carTire,
  'piggy-coin': piggyCoin,
  'shield-happy': shieldHappy,
  'shield-cracked': shieldCracked,
  'face-calm': faceCalm,
  'face-euphoria': faceEuphoria,
  'face-panic': facePanic,
  'face-despair': faceDespair,
  'face-hesitate': faceHesitate,
  'face-greed': faceGreed,
  'lever-coin': leverCoin,
  'gold-trophy': goldTrophy,
  'pig-pink': pigPink,
  'pig-grey': pigGrey,
  'pig-green': pigGreen,
  'pig-blue': pigBlue,
  'pig-purple': pigPurple,
  'pig-red': pigRed,
  'pig-yellow': pigYellow,
  'pig-orange': pigOrange,
  'pig-teal': pigTeal
};

export type SpriteName = keyof typeof SPRITES;

export const spriteSrc = (name: SpriteName) => SPRITES[name];

/** The car the money buys: the whole car, then the body with its cabin cut away, then a single tire. */
export const carFor = (share: number): SpriteName =>
  share >= 0.9 ? 'car-full' : share >= 0.6 ? 'car-partial' : 'car-tire';

/** `bob` makes it bob gently, for a character that is pleased. */
export const Sprite = ({
  name,
  size,
  className,
  bob
}: {
  name: SpriteName;
  size?: number;
  className?: string;
  bob?: boolean;
}) => (
  <img
    className={`sprite${bob ? ' is-bob' : ''}${className ? ` ${className}` : ''}`}
    src={SPRITES[name]}
    data-sprite={name}
    alt=""
    width={size}
    decoding="async"
    draggable={false}
  />
);
